var _excluded = ["isHidden", "isViewMode", "labelProps", "isInvalid"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// The theme is located at the `container` section of Form.theme
// Due to how chakra implements this internally
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/components/form.ts#L24-L28
import { FormControl as ChakraFormControl } from '@chakra-ui/react';
import { forwardRef } from '../../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var FormControl = forwardRef((_ref, ref) => {
  var {
    isHidden,
    isViewMode,
    labelProps,
    isInvalid
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(ChakraFormControl, _objectSpread(_objectSpread({
    "data-component": "FormControl"
  }, props), {}, {
    "data-hidden": isHidden || null,
    "data-view-mode": isViewMode,
    ref: ref,
    label: labelProps === null || labelProps === void 0 ? void 0 : labelProps.label,
    isInvalid: isInvalid
  }));
});
FormControl.displayName = 'FormControl';
//# sourceMappingURL=FormControl.js.map